import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BusinessAccount, HttpService } from 'app/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { emailValidator } from 'validators';
import { BaseModal } from '../base-modal';
import { locale as english } from '../i18n/en';

@Component({
  selector: 'app-edit-customer-modal',
  templateUrl: './edit-customer-modal.component.html',
  styleUrls: ['./edit-customer-modal.component.scss'],
})
export class EditCustomerModalComponent
  extends BaseModal
  implements OnInit, OnDestroy {
  customerForm: FormGroup;
  businessTypes: any[];

  private _unsubscribeAll: Subject<any>;
  private customer: any;

  constructor(
    private httpService: HttpService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    protected dialogRef: MatDialogRef<EditCustomerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(dialogRef, data);

    this._fuseTranslationLoaderService.loadTranslations(english);

    this.customer = this.data.customer;

    this.customerForm = new FormGroup({
      businessName: new FormControl(this.customer.name, [Validators.required, Validators.maxLength(42)]),
      businessType: new FormControl(this.customer.segment_id, [
        Validators.required,
      ]),
      extCustId: new FormControl(this.customer.ext_cust_id),
      contactFirstName: new FormControl(this.customer.contact_first_name, [
        Validators.required,
      ]),
      contactLastName: new FormControl(this.customer.contact_last_name, [
        Validators.required,
      ]),
      contactEmail: new FormControl(this.customer.contact_email, [
        emailValidator(),
      ]),
      contactPhone: new FormControl(this.customer.contact_phone),
    });

    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    // Get current list of business types
    this.httpService
      .getBusinessTypes()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((types) => {
        this.businessTypes = types;
      });

    this.showDialog();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  sendCustomer(): void {
    const newCustomer: BusinessAccount = {
      id: this.customer.id,
      name: this.customerForm.get('businessName').value,
      segment_id: this.customerForm.get('businessType').value,
      ext_cust_id: this.customerForm.get('extCustId').value,
      contact_first_name: this.customerForm.get('contactFirstName').value,
      contact_last_name: this.customerForm.get('contactLastName').value,
      contact_email: this.customerForm.get('contactEmail').value,
      contact_phone: this.customerForm
        .get('contactPhone')
        .value.replace(/-/g, ''),
    };

    this.dialogRef.close(newCustomer);
  }
}
